/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1525
 */

module.exports = {
  wrapper: "FlyoutComponents_wrapper__1sjF8"
}
